import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api, apiError } from "../lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function LegalNameGate() {
  const { user, patchUser } = useAuth();
  const [form, setForm] = useState({ legal_name: "", preferred_name: "", legal_name_private: true, preferred_name_private: false });
  const [saving, setSaving] = useState(false);

  if (!user || !user.needs_legal_name) return null;

  const submit = async () => {
    if (!form.legal_name.trim()) { toast.error("Your legal name is required."); return; }
    setSaving(true);
    try {
      const { data } = await api.post("/users/me/legal-name", form);
      patchUser(data);
      toast.success("Thank you — your legal name is on file.");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={true}>
      <DialogContent className="border-4 border-black bg-spotter-cream max-w-md" data-testid="legal-name-gate" onEscapeKeyDown={(e) => e.preventDefault()} onPointerDownOutside={(e) => e.preventDefault()} onInteractOutside={(e) => e.preventDefault()}>
        <DialogTitle className="font-display text-2xl font-bold text-spotter-maroon flex items-center gap-2"><ShieldCheck className="w-6 h-6" />One quick thing</DialogTitle>
        <p className="text-sm text-spotter-maroon">Unfortunately, due to legal purposes, members must provide their legal name, and optionally can provide a preferred name. Both can be toggled to be private to the public, but for safety reasons the Site Owner and Admins will be able to see this information. Thank you for your understanding. 🐆</p>
        <div>
          <Label>Legal name <span className="text-red-700">*</span></Label>
          <Input data-testid="gate-legal-name" value={form.legal_name} onChange={(e) => setForm({ ...form, legal_name: e.target.value })} placeholder="Your legal first & last name" className="border-2 border-black" />
          <label className="flex items-center gap-2 text-xs text-spotter-maroon mt-1">
            <input type="checkbox" data-testid="gate-legal-private" checked={form.legal_name_private} onChange={(e) => setForm({ ...form, legal_name_private: e.target.checked })} />
            Keep my legal name private from the public
          </label>
        </div>
        <div>
          <Label>Preferred name (optional)</Label>
          <Input data-testid="gate-preferred-name" value={form.preferred_name} onChange={(e) => setForm({ ...form, preferred_name: e.target.value })} placeholder="What you'd like to be shown as" className="border-2 border-black" />
          <label className="flex items-center gap-2 text-xs text-spotter-maroon mt-1">
            <input type="checkbox" data-testid="gate-preferred-private" checked={form.preferred_name_private} onChange={(e) => setForm({ ...form, preferred_name_private: e.target.checked })} />
            Keep my preferred name private from the public
          </label>
        </div>
        <Button data-testid="gate-submit" onClick={submit} disabled={saving} className="bg-spotter-maroon text-spotter-cream border-2 border-black w-full">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save & continue"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
